import useLanguage from '@/utils/hooks/language/useLanguage';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { classNames } from '@/utils';

// Lib
import { platform_language } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

// Type
import type { DropdownBaseButtonProps } from '@/components/base/Dropdown';
// Component
import Dropdown, { BaseItem, NO_BACKGROUND_BLACK } from '@/components/base/Dropdown';

const SwitchLanguage = ({ buttonStyle }: DropdownBaseButtonProps) => {
    const { t } = useTranslation();
    const { lang } = useTranslation();
    const { setLanguageLocalStorage } = useLanguage();

    return (
        <Dropdown
            button={
                <Dropdown.BaseButton buttonStyle={buttonStyle}>
                    <span
                        className={classNames('uppercase', {
                            underline: buttonStyle === NO_BACKGROUND_BLACK
                        })}>
                        {lang}
                    </span>
                </Dropdown.BaseButton>
            }
            size="sm">
            {platform_language(t).map((language) => {
                return (
                    <Dropdown.Item
                        key={language.value}
                        onClick={async () => setLanguageLocalStorage(language.value)}>
                        {({ active }) => (
                            <BaseItem active={active}>
                                <span
                                    className={classNames('test uppercase', {
                                        'font-GBold text-icoBlue': lang === language.value
                                    })}>
                                    {language.value}
                                </span>
                            </BaseItem>
                        )}
                    </Dropdown.Item>
                );
            })}
        </Dropdown>
    );
};

export default SwitchLanguage;
